export default function /* @ngInject */ ProductsResource($resource, config) {
    const urlBase = `${config.accountsApiUrl}/api/v1/stripe`;
    let actions = {
        api: {
            url: `${urlBase}/products`,
            method: 'GET',
            isArray: true,
            cached: true,
            transformResponse: toVisionProducts
        },
        get: {
            url: `${urlBase}/products`,
            method: 'GET',
            cached: true,
            isArray: true,
            transformResponse: toProducts
        },
        apiStatus: {
            url: `${urlBase}/subscription-status?group=:groupId&subscribedProductId=:subscribedProductId`,
            method: 'GET',
            cached: true
        }
    };

    return $resource(urlBase, {}, actions);
}

function toProducts(data) {
    const productsData = angular.fromJson(data);
    const products = productsData.sort((a, b) => {
        if (a.price === b.price) {
            return 0;
        }
        return (a.price > b.price) ? 1 : -1;
    });

    return products.map((product) => {
        if (!product.meta_data) {
            return product;
        }
        product.meta_data = angular.fromJson(product.meta_data);
        return product;
    });
}

function toVisionProducts(data) {
    const products = toProducts(data);
    const infinityPlan = {
        description: 'Contact us for special needs!',
        name: 'More',
        is_infinity: true
    };
    products.push(infinityPlan);

    return products;
}



// WEBPACK FOOTER //
// ./payments/resources/products.js